import React from 'react'
import { Form } from 'antd'
import { RichTextEditor } from 'packages/components/RichText'

export const EditAnalyze: React.FC<{
  disabled?: boolean
}> = ({ disabled }) => {
  return (
    <Form.Item
      label={'解析'}
      name="analysis"
      rules={[{ required: true, message: '请输入解析' }]}
    >
      <RichTextEditor
        minHeight={64}
        readOnly={!!disabled}
        excludeKeys={[
          'headerSelect',
          'group-upload',
          'insertLink',
          'fullScreen',
        ]}
        insertKeys={{
          index: 17,
          keys: ['uploadImage', 'insertFormula'],
        }}
      />
    </Form.Item>
  )
}
